export function initConfetti() {
    const canvas = document.getElementById('confettiCanvas');
    if (!canvas) return;
    const colors = ['#F27A42', '#9DA4EF', '#D0CF2B', '#EFAFDB', '#21415B'];
    const goat = new Path2D("M485.2,105.5c-.1-4.1-4.7-6.5-8.2-4.2-18.4,12.2-65.4,41-79.9,25.9-6.1-7.4-8.3-19.6-5.8-31.8,3.8-17.7,13.1-45.7,57.6-56.8,5.7-1.4,6.2-9.5.7-11.3-78.4-26.5-113.1,63.9-113.1,63.9-1.2-27.3,19.5-47,31.7-56.1,3.2-2.4,2-7.5-1.9-8.1-71-11-82.8,104.4-109.2,130.8-27.6,27.6-68.2,58.7-68.2,58.7-20.7,16.8-24.7,47-9.1,68.8,9.3,13,24.9,20.8,41.6,20.8s8.5-.5,12.7-1.5l20.7-5,23.1-5.5c-4.4,12.3-53.4,46.4-167.4,81.1-14.7,4.5-31.1-3.4-35.3-18.2-6.2-21.8,4-39.3,13-49.6,4.3-5-1.2-12.2-7.2-9.6-23.4,10.1-52.4,50.1-52.4,95.1v191.2c0,24,19.5,43.5,43.5,43.5h1.4c24,0,43.6-19.6,43.6-43.6v-79.3c0-17.2,14.1-31.3,31.3-31.3h1.4c17.2,0,31.3,14.1,31.3,31.3v79.4c0,23.9,19.6,43.5,43.5,43.5h1.4c24,0,43.6-19.5,43.6-43.5v-79.5c0-17.2,14-31.2,31.2-31.2h1.5c17.2,0,31.2,14,31.2,31.2v79.5c0,24,19.5,43.5,43.6,43.5h1.4c24,0,43.5-19.5,43.5-43.5v-27.3l1.1-364.2c0-8.9,5.9-16.7,14.6-18.9,44.8-5.5,48.5-48.7,47.9-68ZM328.2,202.4c-1.1,5.9-6,10.8-11.9,11.9-1,.3-2,.4-3,.4-4.6,0-8.9-2.1-11.8-5.5-2.9-3.5-4.1-8.1-3.2-12.7,1.2-5.9,6-10.8,11.9-12,1-.2,2-.3,3-.3,4.6,0,8.9,2,11.8,5.5,2.9,3.5,4.1,8.1,3.2,12.7Z");
    const shapes = ['square', 'circle', 'triangle'];
    const ctx = canvas.getContext('2d');
    let confetti = [];
    let confettiPerFrame = 0;
    let maxParticles = 0;
    let spawnCooldown = 0;

    function resizeCanvas() {
        // Try to get the canvas parent container first, fallback to formContainer
        let container = canvas.parentElement;
        if (!container) {
            container = document.getElementById('formContainer');
        }
        if (!container) return;

        const rect = container.getBoundingClientRect();

        canvas.width = rect.width;
        canvas.height = rect.height;

        canvas.style.width = `${rect.width}px`;
        canvas.style.height = `${rect.height}px`;

        confettiPerFrame = Math.min(Math.floor(rect.width / 100), 10);
        maxParticles = Math.floor(rect.width * 0.3);

        if (confetti.length > maxParticles) {
            confetti.splice(0, confetti.length - maxParticles);
        }
    }

    function createConfetto() {
        const size = (Math.random() * 6 + 4) * 3;
        return {
            x: Math.random() * canvas.width,
            y: -10,
            w: size,
            h: size * (Math.random() > 0.5 ? 1 : 0.6),
            color: colors[Math.floor(Math.random() * colors.length)],
            speed: Math.random() * 1.5 + 0.5,
            rotation: Math.random() * 2 * Math.PI,
            rotationSpeed: (Math.random() - 0.5) * 0.1,
            shape: shapes[Math.floor(Math.random() * shapes.length)],
            scaleX: 1,
            scaleSpeed: (Math.random() * 0.1) + 0.05,
        };
    }

    function drawConfetto(c) {
        ctx.save();
        ctx.translate(c.x, c.y);
        ctx.rotate(c.rotation);
        ctx.scale(Math.sin(c.scaleX), 1);
        ctx.fillStyle = c.color;

        // Draw your custom SVG path
        ctx.scale(c.w / 514, c.h / 650); // match original SVG dimensions
        ctx.fill(goat);

        ctx.restore();

        // ctx.save();
        // ctx.translate(c.x, c.y);
        // ctx.rotate(c.rotation);
        // ctx.scale(Math.sin(c.scaleX), 1);
        // ctx.fillStyle = c.color;
        //
        // switch (c.shape) {
        //     case 'circle':
        //         ctx.beginPath();
        //         ctx.arc(0, 0, c.w / 2, 0, Math.PI * 2);
        //         ctx.fill();
        //         break;
        //     case 'triangle':
        //         ctx.beginPath();
        //         ctx.moveTo(0, -c.h / 2);
        //         ctx.lineTo(c.w / 2, c.h / 2);
        //         ctx.lineTo(-c.w / 2, c.h / 2);
        //         ctx.closePath();
        //         ctx.fill();
        //         break;
        //     default:
        //         ctx.fillRect(-c.w / 2, -c.h / 2, c.w, c.h);
        // }
        //
        // ctx.restore();
    }

    function update() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (confetti.length < maxParticles) {
            spawnCooldown++;
            if (spawnCooldown >= (15 / confettiPerFrame)) {
                confetti.push(createConfetto());
                spawnCooldown = 0;
            }
        }

        for (let i = confetti.length - 1; i >= 0; i--) {
            const c = confetti[i];
            c.y += c.speed;
            c.rotation += c.rotationSpeed;
            c.scaleX += c.scaleSpeed;
            if (c.scaleX > Math.PI * 2) c.scaleX = 0;

            if (c.y > canvas.height + 20) {
                confetti.splice(i, 1);
            } else {
                drawConfetto(c);
            }
        }

        requestAnimationFrame(update);
    }

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    update();
}
